export default {
  'policy.privacy.title_1':
    '<h3>Privacy Policy</h3>' +
    'GMPD Culture Promotion Association Privacy Statement and Personal Data Consent' +
    '<br />' +
    'Last Updated: August 31, 2025',
  'policy.privacy.title_2':
    'The GMPD Culture Promotion Association (hereinafter referred to as "the Association") values the protection of applicants’ and members’ personal data and privacy. To safeguard your rights and comply with the Personal Data Protection Act, we hereby explain our policies on the collection, use, and management of personal data.',
  'policy.privacy.paragraph_1':
    '<h4>1. Purpose of Collecting Personal Data</h4>' +
    'The Association collects your personal data for the following purposes:' +
    '<ul>' +
    '<li>Membership qualification review and identity verification</li>' +
    '<li>Event registration, ticket distribution, and notifications</li>' +
    '<li>Providing member-only services and features (e.g., member login, club registration, notifications)</li>' +
    '<li>Event security and access management</li>' +
    '<li>Member services and handling inquiries</li>' +
    '<li>Statistical analysis and event improvement (without disclosing individual data)</li>' +
    '</ul>',
  'policy.privacy.paragraph_2':
    '<h4>2. Types of Personal Data Collected</h4>' +
    'Based on the membership application form you submit, we may collect the following information:' +
    '<ul>' +
    '<li>Name</li>' +
    '<li>Date of birth</li>' +
    '<li>National ID number</li>' +
    '<li>Contact information (e.g., Email, LINE ID, social media accounts)</li>' +
    '<li>Address</li>' +
    '<li>Gender and sexual orientation (used solely to verify membership eligibility, not disclosed publicly)</li>' +
    '<li>Personal interests / club creation profile (for activity review purposes)</li>' +
    '</ul>',
  'policy.privacy.paragraph_3':
    '<h4>3. Usage and Retention of Personal Data</h4>' +
    'Your personal data will be used within Taiwan for the duration of your membership or as required for event management.' +
    '<br />' +
    'Your data will only be used internally within the Association and will not be disclosed, transferred, sold, or rented to any third party.' +
    '<br />' +
    'Unless required by law or with your written consent, your data will not be shared with third parties.',
  'policy.privacy.paragraph_4':
    '<h4>4. Data Protection Measures</h4>' +
    'The Association will adopt appropriate technical and administrative security measures to protect your personal data against unauthorized access, leakage, alteration, or destruction.',
  'policy.privacy.paragraph_5':
    '<h4>5. Your Rights</h4>' +
    'In accordance with Article 3 of the Personal Data Protection Act, you may request the following from the Association:' +
    '<ul>' +
    '<li>Access or review your personal data</li>' +
    '<li>Request copies</li>' +
    '<li>Request supplements or corrections (with valid reasons)</li>' +
    '<li>Request to suspend collection, processing, or use</li>' +
    '<li>Request deletion (which will terminate your membership)</li>' +
    '</ul>' +
    'Please submit written or electronic requests through the Association’s contact channels, and we will process them within a reasonable time.',
  'policy.privacy.paragraph_6':
    '<h4>6. Miscellaneous</h4>' +
    'If you are under 18, please do not apply for membership.' +
    '<br />' +
    'If you do not agree to these terms, please do not complete the membership application form.' +
    '<br />' +
    'The Association reserves the right to modify these terms at any time due to legal or operational needs. The latest version will be published on the official website or official platforms.',
  'policy.usage.title':
    '<h3>Membership Terms</h3>' +
    'Please read the following terms carefully. By applying for membership, you confirm that you understand and agree.',
  'policy.usage.paragraph_1':
    '<h4>1. Membership Eligibility</h4>' +
    '<ol>' +
    '<li>Applicants must be male, aged 18 or older, with full legal capacity.</li>' +
    '<li>Applicants must be biologically male and have a sexual orientation toward men.</li>' +
    '<li>Applicants must fully understand and support the core values of GMPD culture promoted by the Association and participate with respect and friendliness.</li>' +
    '<li>The Association reserves the right to approve or revoke membership without obligation to disclose reasons.</li>' +
    '</ol>',
  'policy.usage.paragraph_2':
    '<h4>2. Member Obligations</h4>' +
    '<ol>' +
    '<li>Comply with the Association’s regulations and event rules.</li>' +
    '<li>Respect other members’ sexual orientation, personality, physical characteristics, and privacy.</li>' +
    '<li>Follow event procedures and staff instructions to maintain a friendly and safe environment.</li>' +
    '<li>Do not act under the Association’s name to infringe rights, harass, defraud, or damage the Association’s reputation.</li>' +
    '<li>If violations persist despite warnings, the Association may suspend or terminate membership.</li>' +
    '</ol>',
  'policy.usage.paragraph_3':
    '<h4>3. Prohibited Conduct</h4>' +
    'The following actions will result in suspension or termination of membership:' +
    '<ul>' +
    '<li>Discrimination, insults, exclusion, or attacks against gay men or diverse body types.</li>' +
    '<li>Using the Association’s platform for personal harassment, inappropriate advances, or coercion.</li>' +
    '<li>Causing disruption, division, or disorder during events or in the community.</li>' +
    '<li>Unauthorized use of the Association’s name for commercial or non-commercial purposes.</li>' +
    '<li>Spreading misleading information or impersonating others to apply for membership.</li>' +
    '</ul>',
  'policy.usage.paragraph_4':
    '<h4>4. Use of Personal Data</h4>' +
    '<ol>' +
    '<li>Personal data provided by members will be used solely for internal review and communication within the Association.</li>' +
    '<li>The Association will not disclose member data publicly nor share it with third parties.</li>' +
    '<li>Members may request access, correction, or deletion of their personal data.</li>' +
    '</ol>',
  'policy.usage.paragraph_5':
    '<h4>5. Miscellaneous</h4>' +
    '<ol>' +
    '<li>The Association may amend these terms as needed and will announce updates on official platforms. Individual notifications will not be sent.</li>' +
    '<li>If a member disagrees with the amendments, they may request to withdraw from membership at any time.</li>' +
    '<li>If there is any inconsistency between the Chinese and other language versions, the Chinese version shall prevail.</li>' +
    '</ol>',
};
